import React, { useState } from 'react';

const ExcepcionesCalendario = ({
  mesSeleccionado,
  excepcionesCalendario,
  onMesChange,
  onDiaClick,
  loading = false
}) => {
  const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  const nombresDias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

  const getPrimerDia = (fecha) => new Date(fecha.getFullYear(), fecha.getMonth(), 1).getDay();
  const getDiasEnMes = (fecha) => new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0).getDate();

  const getExcepcionesEnDia = (dia) => {
    const fechaBuscada = `${mesSeleccionado.getFullYear()}-${String(mesSeleccionado.getMonth() + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    return excepcionesCalendario.filter(exc => {
      const fechaExc = exc.fecha.split('T')[0];
      return fechaExc === fechaBuscada;
    });
  };

  const handlePrevMes = () => {
    const newDate = new Date(mesSeleccionado);
    newDate.setMonth(newDate.getMonth() - 1);
    onMesChange(newDate);
  };

  const handleNextMes = () => {
    const newDate = new Date(mesSeleccionado);
    newDate.setMonth(newDate.getMonth() + 1);
    onMesChange(newDate);
  };

  const handleDiaClick = (dia) => {
    const fecha = `${mesSeleccionado.getFullYear()}-${String(mesSeleccionado.getMonth() + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    onDiaClick(fecha);
  };

  const renderCalendario = () => {
    const primerDia = getPrimerDia(mesSeleccionado);
    const diasEnMes = getDiasEnMes(mesSeleccionado);
    const celdas = [];

    // Celdas vacías antes del primer día
    for (let i = 0; i < primerDia; i++) {
      celdas.push(<td key={`empty-${i}`} style={{ backgroundColor: '#fafafa' }}></td>);
    }

    // Celdas con días
    for (let dia = 1; dia <= diasEnMes; dia++) {
      const excepciones = getExcepcionesEnDia(dia);
      let cellBg = 'white';
      let cellClass = '';

      if (excepciones.length > 0) {
        const tieneCerrado = excepciones.some(e => e.tipo === 'cerrado');
        const tieneEspecial = excepciones.some(e => e.tipo === 'horario_especial');

        if (tieneCerrado && tieneEspecial) {
          cellBg = 'linear-gradient(135deg, #fef3c7 0%, #fee2e2 100%)';
          cellClass = 'multiples';
        } else if (tieneCerrado) {
          cellBg = '#fee2e2';
          cellClass = 'cerrado';
        } else if (tieneEspecial) {
          cellBg = '#fef3c7';
          cellClass = 'horario-especial';
        }
      }

      const hoy = new Date();
      const esDiaHoy = dia === hoy.getDate() &&
                       mesSeleccionado.getMonth() === hoy.getMonth() &&
                       mesSeleccionado.getFullYear() === hoy.getFullYear();

      if (esDiaHoy && cellClass === '') {
        cellBg = '#eff6ff';
        cellClass = 'hoy';
      }

      celdas.push(
        <td
          key={dia}
          onClick={() => handleDiaClick(dia)}
          className={cellClass}
          style={{
            backgroundColor: cellBg,
            cursor: 'pointer',
            textAlign: 'center',
            padding: '0.5rem',
            minHeight: '80px',
            verticalAlign: 'top',
            border: '1px solid #e5e7eb',
            transition: 'all 0.2s',
            position: 'relative'
          }}
          onMouseOver={(e) => !loading && (e.target.style.backgroundColor = cellBg === 'white' ? '#f9fafb' : cellBg)}
          onMouseOut={(e) => e.target.style.backgroundColor = cellBg}
        >
          <div style={{ fontWeight: '600', fontSize: '0.95rem', marginBottom: '0.25rem', color: '#374151' }}>
            {dia}
          </div>
          {excepciones.length > 0 && (
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
              {excepciones.length > 1 ? `${excepciones.length} excepciones` : '1 excepción'}
            </div>
          )}
        </td>
      );
    }

    return celdas;
  };

  return (
    <div style={{ marginTop: '2rem' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#374151', marginBottom: '1rem' }}>
        📅 Calendario de Excepciones
      </h2>

      {/* Navegación mes */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1.5rem',
        padding: '1rem',
        backgroundColor: '#f9fafb',
        borderRadius: '8px',
        border: '1px solid #e5e7eb'
      }}>
        <button
          onClick={handlePrevMes}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600'
          }}
          disabled={loading}
        >
          ← Anterior
        </button>

        <h3 style={{ margin: 0, color: '#1f2937', fontWeight: '600' }}>
          {meses[mesSeleccionado.getMonth()]} {mesSeleccionado.getFullYear()}
        </h3>

        <button
          onClick={handleNextMes}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600'
          }}
          disabled={loading}
        >
          Siguiente →
        </button>
      </div>

      {/* Calendario */}
      <div style={{ overflowX: 'auto' }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          backgroundColor: 'white',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
              {nombresDias.map(dia => (
                <th
                  key={dia}
                  style={{
                    padding: '0.75rem',
                    textAlign: 'center',
                    fontWeight: '700',
                    color: '#374151'
                  }}
                >
                  {dia}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[...Array(Math.ceil(renderCalendario().length / 7))].map((_, weekIdx) => (
              <tr key={weekIdx}>
                {renderCalendario().slice(weekIdx * 7, (weekIdx + 1) * 7)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Leyenda */}
      <div style={{
        marginTop: '1.5rem',
        display: 'flex',
        gap: '2rem',
        padding: '1rem',
        backgroundColor: '#f9fafb',
        borderRadius: '8px',
        fontSize: '0.9rem',
        color: '#6b7280'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <div style={{ width: '20px', height: '20px', backgroundColor: '#fee2e2', borderRadius: '3px' }}></div>
          <span>Cerrado</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <div style={{ width: '20px', height: '20px', backgroundColor: '#fef3c7', borderRadius: '3px' }}></div>
          <span>Horario Especial</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <div style={{ width: '20px', height: '20px', backgroundColor: '#eff6ff', borderRadius: '3px', border: '2px solid #3b82f6' }}></div>
          <span>Hoy</span>
        </div>
      </div>

      <div style={{
        marginTop: '1rem',
        padding: '0.75rem',
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe',
        borderRadius: '6px',
        fontSize: '0.9rem',
        color: '#1e40af'
      }}>
        💡 <strong>Tip:</strong> Haz click en un día para agregar una excepción
      </div>
    </div>
  );
};

export default ExcepcionesCalendario;
